export default {
    bloglist: {
        en: [
            // {
            //     title: 'How to Change Fonts on GBWhatsApp Easily',
            //     poster: require('@/assets/blog-1.webp'),
            //     desc: "GBWhatsApp is one of the most popular WhatsApp mods in 2025, loved for its extra features and customization options. Among its most sought-after features is the ability to change fonts in GBWhatsApp — giving your chats a fresh, stylish look.",
            //     name: 'en-blog1',
            //     url: 'https://gbwatsapk.com/how-change-fonts-on-gbwhatsapp/',
            //     date:"2025-08-15",
            // }
        ],
    }
    
}